import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import dashboardMockup from "@/assets/dashboard-mockup.webp";
import dashboardMockupSmall from "@/assets/dashboard-mockup-600.webp";
import dashboardMockupMedium from "@/assets/dashboard-mockup-800.webp";

const HeroSection = () => (
  <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden bg-gradient-to-b from-[hsl(200,100%,97%)] to-background text-foreground">
    <div className="container mx-auto px-4 lg:px-8 text-center">


      <motion.div
        className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary/30 bg-primary/10 backdrop-blur-sm shadow-sm mb-8 text-sm font-bold text-primary hover:bg-primary/20 transition-colors"
      >

        #1 Trusted School ERP System in Ethiopia
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="text-4xl md:text-5xl lg:text-7xl font-heading font-extrabold text-slate-800 dark:text-slate-100 mb-6 leading-tight max-w-4xl mx-auto tracking-tight"
      >
        All-in-One School Management System for Modern Institutions
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="text-lg md:text-xl text-slate-500 dark:text-slate-400 mb-10 leading-relaxed max-w-3xl mx-auto font-medium"
      >
        Manage students, teachers, attendance, fees, exams, and communication in one powerful platform designed to simplify school administration and improve efficiency for Ethiopian schools, colleges, and educational institutions.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16"
      >
        <Link to="/contact">
          <Button size="xl" className="w-full sm:w-auto text-base bg-primary hover:bg-primary/90 text-primary-foreground rounded-xl shadow-lg shadow-primary/20 font-semibold px-8 h-14">
            Get a Free Demo <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </Link>
        <Link to="/features">
          <Button variant="outline" size="xl" className="w-full sm:w-auto text-base border-slate-200 hover:bg-primary/5 hover:text-primary hover:border-primary/30 rounded-xl font-semibold px-8 h-14 bg-white text-slate-700 transition-colors">
            View Features
          </Button>
        </Link>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="max-w-[70rem] mx-auto px-4 lg:px-0"
      >
        <div className="relative">
          <img
            src={dashboardMockup}
            srcSet={`${dashboardMockupSmall} 600w, ${dashboardMockupMedium} 800w, ${dashboardMockup} 1200w`}
            sizes="(max-width: 640px) calc(100vw - 64px), min(70rem, calc(100vw - 64px))"
            alt="eSchool Admin Dashboard Screenshot"
            width="1200"
            height="802"
            loading="eager"
            {...{ fetchpriority: "high" }}
            className="w-full h-auto object-cover"
          />
          {/* Bottom shadow fade */}
          <div className="absolute bottom-0 inset-x-0 h-32 bg-gradient-to-t from-background to-transparent pointer-events-none" />
        </div>
      </motion.div>
    </div>
  </section>
);

export default HeroSection;
